import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const AGB = () => {
  return (
    <div className="min-h-screen bg-[var(--color-light)] py-12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8"
      >
        <h1 className="text-3xl font-bold text-[var(--color-text-dark)] mb-6">Allgemeine Geschäftsbedingungen (AGB)</h1>
        
        <div className="prose prose-lg max-w-none text-[var(--color-text-light)]">
          <p className="mb-4">
            Platzhalter für Allgemeine Geschäftsbedingungen.
          </p>
          
          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">§1 Geltungsbereich</h2>
          <p className="mb-4">
            Diese AGB gelten für alle Verträge zwischen [Ihr Unternehmen] und dem Nutzer.
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">§2 Vertragsgegenstand</h2>
          <p className="mb-4">
            Gegenstand des Vertrages ist die Bereitstellung von Tools und Dienstleistungen nach Kauf.
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">§3 Nutzungsrechte</h2>
          <p className="mb-4">
            Der Nutzer erhält nach Kauf ein einfaches, nicht übertragbares Nutzungsrecht.
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">§4 Haftung</h2>
          <p className="mb-4">
            Die Haftung richtet sich nach den gesetzlichen Bestimmungen.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-[var(--color-border)]">
          <Link to="/login" className="text-[var(--color-primary)] hover:underline">
            ← Zurück zur Anmeldung
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default AGB;